export default [
  {
    slug: "/satilik-daire/sahibinden",
    value: "Sahibinden Satılık Daire",
  },
  {
    slug: "/kiralik-daire/sahibinden",
    value: "Sahibinden Kiralık Daire",
  },
  {
    slug: "/satilik-daire",
    value: "Satılık Daire",
  },
  {
    slug: "/kiralik-daire",
    value: "Kiralık Daire",
  },
  {
    slug: "/satilik-arsa",
    value: "Satılık Arsa",
  },
  {
    slug: "/gunluk-kiralik-konut",
    value: "Günlük Kiralık Ev",
  },
];
